import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login/Login';
import Menu from './pages/Menu/Menu';
import RelatorioCusto from './pages/PowerBI/Interno/RelatorioCusto/PowerBI';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  const handleLogin = (route: string) => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const PowerBIPageLoader = (cityName: string, routeType: 'Prefeitura' | 'Interno' | 'Diversos') => {
    const PageComponent = lazy(() => import(`./pages/PowerBI/${routeType}/${cityName}/PowerBI`));
    return (
      <Suspense fallback={<div>Carregando...</div>}>
        <PageComponent />
      </Suspense>
    );
  };

  return (
    <Router>
      <div className="App">
        <main>
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/menu" element={<Menu/>} />
            <Route path="/alexania" element={PowerBIPageLoader('Alexania', 'Prefeitura')} />
            <Route path="/amapa" element={PowerBIPageLoader('Amapa', 'Prefeitura')} />
            <Route path="/angra" element={PowerBIPageLoader('Angra', 'Prefeitura')} />
            <Route path="/aparecidagoiania" element={PowerBIPageLoader('AparecidaGoiania', 'Prefeitura')} />
            <Route path="/araguaina" element={PowerBIPageLoader('Araguaina', 'Prefeitura')} />
            <Route path="/gurupi" element={PowerBIPageLoader('Gurupi', 'Prefeitura')} />
            <Route path="/manaus" element={PowerBIPageLoader('Manaus', 'Prefeitura')} />
            <Route path="/mariana2022" element={PowerBIPageLoader('Mariana2022', 'Prefeitura')} />
            <Route path="/mariana2025" element={PowerBIPageLoader('Mariana2025', 'Prefeitura')} />
            <Route path="/mariana2025-financas" element={PowerBIPageLoader('Mariana2025Financas', 'Prefeitura')} />
            <Route path="/maracanau" element={PowerBIPageLoader('Maracanau', 'Prefeitura')} />
            <Route path="/parauapebas" element={PowerBIPageLoader('Parauapebas', 'Prefeitura')} />
            <Route path="/ribeiraoneves" element={PowerBIPageLoader('RibeiraoNeves', 'Prefeitura')} />
            <Route path="/riobranco" element={PowerBIPageLoader('RioBranco', 'Prefeitura')} />
            <Route path="/goiania" element={PowerBIPageLoader('Goiania', 'Prefeitura')} />
            <Route path="/nelog" element={PowerBIPageLoader('PortopecemNelog', 'Prefeitura')} />
            <Route path="/goiania-financas" element={PowerBIPageLoader('GoianiaFinancas', 'Prefeitura')} />
            <Route path="/codevasf" element={PowerBIPageLoader('Codevasf', 'Prefeitura')} />
            <Route path="/codevasf-producao" element={PowerBIPageLoader('Codevasf_Producao', 'Prefeitura')} />
            <Route path="/vitoriaconquista2022" element={PowerBIPageLoader('VitoriaConquista2022', 'Prefeitura')} />
            <Route path="/vitoriaconquista2025" element={PowerBIPageLoader('VitoriaConquista2025', 'Prefeitura')} />
            <Route path="/vicosa" element={PowerBIPageLoader('Vicosa', 'Prefeitura')} />
            <Route path="/saoborja" element={PowerBIPageLoader('SaoBorja', 'Prefeitura')} />
            <Route path="/lagarto" element={PowerBIPageLoader('Lagarto', 'Prefeitura')} />
            <Route path="/caxiasdosul" element={PowerBIPageLoader('CaxiasDoSul', 'Prefeitura')} />
            <Route path="/pantanogrande" element={PowerBIPageLoader('PantanoGrande', 'Prefeitura')} />
            <Route path="/novalima" element={PowerBIPageLoader('NovaLima', 'Prefeitura')} />
            <Route path="/sabara" element={PowerBIPageLoader('Sabara', 'Prefeitura')} />
            <Route path="/santoantonio" element={PowerBIPageLoader('Saj', 'Prefeitura')} />
            <Route path="/palmas" element={PowerBIPageLoader('Palmas', 'Prefeitura')} />
            <Route path="/araraquara" element={PowerBIPageLoader('Araraquara', 'Prefeitura')} />
            <Route path="/araraquara-financas" element={PowerBIPageLoader('AraraquaraFinancas', 'Prefeitura')} />
            <Route path="/araraquara-financas-todos-cenarios" element={PowerBIPageLoader('AraraquaraFinancasTodosCenarios', 'Prefeitura')} />
            <Route path="/santanadoparaiso" element={PowerBIPageLoader('SantanaDoParaiso', 'Prefeitura')} />
            <Route path="/santanadoparaiso-financas" element={PowerBIPageLoader('SantanaDoParaisoFinancas', 'Prefeitura')} />
            <Route path="/abaetetuba" element={PowerBIPageLoader('Abaetetuba', 'Prefeitura')} />
            <Route path="/abaetetuba-financas" element={PowerBIPageLoader('AbaetetubaFinancas', 'Prefeitura')} />
            <Route path="/tucuma" element={PowerBIPageLoader('Tucuma', 'Prefeitura')} />
            <Route path="/seger" element={PowerBIPageLoader('Seger', 'Prefeitura')} />
            <Route path="/atividades" element={PowerBIPageLoader('Atividades', 'Interno')} />
            <Route path="/aviacao" element={PowerBIPageLoader('Aviacao', 'Interno')} />
            <Route path="/cadastro" element={PowerBIPageLoader('Cadastro', 'Interno')} />
            <Route path="/indicadores-sociais" element={PowerBIPageLoader('IndicadoresSociais', 'Interno')} />
            <Route path="/producao" element={PowerBIPageLoader('Producao', 'Interno')} />
            <Route path="/gerencia-execucao" element={PowerBIPageLoader('GerenciaExecucao', 'Interno')} />
            <Route path="/custo" element={PowerBIPageLoader('Custo', 'Interno')} />
            <Route path="/custos-projetos" element={PowerBIPageLoader('CustoProjetos', 'Interno')} />
            <Route path="/comparativo-iptu-itbi" element={PowerBIPageLoader('ComparativoIptuItbi', 'Diversos')} />
            <Route path="/relatorio-custo" element={<RelatorioCusto />} />
            <Route path="/avaliacao-monitoramento-goiania" element={PowerBIPageLoader('AvaliacaoMonitoramentoGoiania', 'Interno')} />
            <Route path="/avaliacao-monitoramento-vitoriadaconquista" element={PowerBIPageLoader('AvaliacaoMonitoramentoVitoriaConquista', 'Interno')} />
            <Route path="/avaliacao-monitoramento-vicosa" element={PowerBIPageLoader('AvaliacaoMonitoramentoVicosa', 'Interno')} />
            <Route path="/avaliacao-monitoramento-horizonte" element={PowerBIPageLoader('AvaliacaoMonitoramentoHorizonte', 'Interno')} />
            <Route path="/acessos-geo360" element={PowerBIPageLoader('AcessosGeo360', 'Interno')} />
            <Route path="/monitoramento-integracoes" element={PowerBIPageLoader('MonitoramentoIntegracoes', 'Interno')} />            
            <Route path="/horizonte" element={PowerBIPageLoader('Horizonte', 'Prefeitura')} />
            <Route path="/horizonte-financas" element={PowerBIPageLoader('HorizonteFinancas', 'Prefeitura')} />
            <Route path="/sei-bahia" element={PowerBIPageLoader('SeiBahia', 'Prefeitura')} />
            <Route path="/visitas-campo" element={PowerBIPageLoader('VisitasCampo', 'Interno')} />
            <Route path="/Picos" element={PowerBIPageLoader('Picos', 'Prefeitura')} />
            <Route path="/picos-financas" element={PowerBIPageLoader('PicosFinancas', 'Prefeitura')} />
            <Route path="/" element={<Navigate replace to={isLoggedIn ? '/menu' : '/login'} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
